// extracted by mini-css-extract-plugin
module.exports = {"mediumRoot":"Medium_mediumRoot__1JuI-","mediumInnerContainer":"Medium_mediumInnerContainer__2gHli"};